<template>
<div class="row">
    <div v-for="(field, index) in fields" :key="index" :class="field.classList">
        <div class="mb-3" v-if="fieldsValues">
            <component
                @input="handleInputValue($event, index)"
                :is="'tic' + field.component.charAt(0).toUpperCase() + field.component.slice(1)"
                :custom-input="false"
                v-bind="field.params"
                :value="fieldsValues[index]"
                :ref="index"
                v-show="field.show !== false"
            >
            </component>
        </div>
    </div>
    <div class="laius">
        <span class="icon-triangle"><i class="fas fa-exclamation-triangle"></i></span>
        <span class="texte">Vos données bancaires ne sont pas stockées</span>
    </div>
</div>

</template>
<script>
import ticTextInfo from '@/components/formation/offline/textInfo'
import ticText from '@/components/frontoffice/form/baseInput/text'
import ticNumber from '@/components/frontoffice/form/baseInput/number'

export default {
  components: {
    ticTextInfo,
    ticText,
    ticNumber
  },
  props: {
    id: {
      type: Number
    },
    value: {
      type: [Object, String]
    }
  },
  data () {
    return {
      fields: {
        number: {
          component: 'text',
          classList: 'col-12',
          params: {
            label: 'Numéro de carte',
            required: true,
            name: 'number',
            placeholder: '#### #### #### ####'
          }
        },
        cardHolder: {
          component: 'text',
          classList: 'col-12',
          params: {
            label: 'Nom du propriétaire',
            required: true,
            name: 'cardHolder',
            placeholder: 'Marc Dupond'
          }
        },
        securityCode: {
          component: 'text',
          classList: 'col-6',
          params: {
            label: 'Cryptogramme',
            required: true,
            name: 'securityCode',
            placeholder: '123'
          }
        },
        valid: {
          component: 'text',
          classList: 'col-6',
          params: {
            label: 'Date de validité',
            required: true,
            name: 'valid',
            mask: '##/##',
            placeholder: '12/25'
          }
        },
        organisation: {
          component: 'text',
          show: false,
          params: {
            required: true,
            name: 'organisation'
          }
        }
      },
      fieldsValues: {},
      amexCardMask: '#### ###### #####',
      otherCardMask: '#### #### #### ####',
      patternDetected: '',
      creditCardType: { 'visa': 'VISA', 'mastercard': 'MASTER', 'amex': 'AMEX', 'aucun': 'UNKNOWN' } // “VISA”, “MASTER”, “AMEX”
    }
  },

  methods: {
    handleInputValue (value, id) {
      if (id === 'number') {
        this.setUpCardMask(value, id)
        const helpMessage = `${this.$t('formation.offline.cb.pattern')} : ${this.$te('formation.offline.cb.' + this.getCardType(value)) ? this.$t('formation.offline.cb.' + this.getCardType(value)) : 'aucun'}`
        this.$refs[id][0].setHelp(helpMessage)
        this.fieldsValues['organisation'] = this.creditCardType[ this.getCardType(value) ]
      }
      this.fieldsValues[id] = value
      this.$emit('input', this.fieldsValues)
    },
    setUpCardMask (value, id) {
      let reg = new RegExp('^(34|37)') // american express pattern

      if (value.match(reg) != null) {
        this.$refs[id][0].setMask(this.amexCardMask)
        this.$refs['securityCode'][0].setMask('####')
      } else {
        this.$refs[id][0].setMask(this.otherCardMask)
        this.$refs['securityCode'][0].setMask('###')
      }
    },
    getCardType (value) {
      let re = new RegExp('^4')
      if (value.match(re) != null) return 'visa'

      re = new RegExp('^(34|37)')
      if (value.match(re) != null) return 'amex'

      re = new RegExp('^(5[1-5]|2221|2720)')
      if (value.match(re) != null) return 'mastercard'

      return 'aucun'
    }
  },
  created () {
    if (this.value != '') {
      this.fieldsValues = this.value
    } else {
      for (let [key, field] of Object.entries(this.fields)) {
        if (!field.hasOwnProperty('dontSave')) {
          this.$set(this.fieldsValues, key, '')
        }
      }
    }
  }

}
</script>
<style lang="scss" scoped>

</style>
